<template>
  <div>
    <div class="modal-overlay"></div>
    <div class="modal" :class="{'modal--white': theme === 'white'}">
      <div class="modal__content">
        <img v-if="theme === 'white'" class="modal__close-btn" src="@/assets/closeBtn-black.png" @click="onCloseBtnClick"/>
        <img v-else class="modal__close-btn" src="@/assets/closeBtn.png" @click="onCloseBtnClick"/>

        <div v-if="!formSubmitted">
          <div class="modal__title">
            Оставить заявку
          </div>          
          <app-input v-for="(item, index) in formData"
                      :key="index"
                      :placeholder="item.placeholder"
                      :value="item.value"
                      :type="item.type"
                      :pattern="item.pattern"
                      :theme="theme" 
                      @onUpdateValue="onUpdateValue(index, $event)"
                      @changeStatus="onChangeStatus(index, $event)"
                      />           
          <ButtonSlider v-if="!formProcessed" msg="Оставить заявку" :theme="theme" @btnClick="onSendBtnClick" />   
          <div v-else>Отправка..</div>  
          <div v-if="formError">{{formError}}</div>  
        </div>
        <div v-else class="modal__title">
          Заявка отправлена!
        </div>

        <!--
        {{formProcessed}}
        {{'formError: ' + formError}} 
        -->
      
      </div>
    </div>  
  </div>  
</template>

<script>
import ButtonSlider from "@/components/ButtonSlider.vue";
import Input from "@/components/Input.vue";

import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  name: "Modal",
  props: {
    theme: {
      type: String,
      required: false,
      default: "",
    },
  },
  components: {
    ButtonSlider,
    "app-input": Input,
  },
  computed: {
    ...mapGetters([
      "formProcessed",
      "formSubmitted",
      "formError",
      "formData",
      "validCnt",
    ]),
  },
  methods: {
    ...mapActions(["sendLetter", "resetForm", "updateValue", "updateStatus"]),
    onCloseBtnClick() {
      this.$emit("closeModal");
      setTimeout(() => {
        this.resetForm();
      }, 1000);
    },
    onSendBtnClick() {
      if (this.validCnt === this.formData.length) {
        let data = this.formData.map(item => {
          return {
            name: item.name,
            value: item.value,
          };
        });
        this.sendLetter(data);
      } else {
        console.log("form not valid");
      }
    },
    onUpdateValue(index, value) {
      this.updateValue({
        index,
        value,
      });
    },
    onChangeStatus(index, status) {
      this.updateStatus({
        index,
        status,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/styles/settings.scss";

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1;
}
.modal {
  position: fixed;
  z-index: 20;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: $black-color;
  border: 1px solid $gray-color;
  color: $white-color;
  width: 55%;
}
.modal--white {
  background-color: $white-color;
  color: $black-color;
}
.modal__content {
  position: relative;
  padding: 50px;
  text-align: center;
}
.modal__close-btn {
  display: block;
  margin: 0 auto 50px;
  cursor: pointer;
}
.modal__title {
  font-size: 2.8rem;
  margin: 30px auto;
}

@media only screen and(max-width: 768px) {
  .modal {
    width: 100%;
  }
}
</style>
